import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectReportTemplates({ uuid }) {
      const res = getState().find(({ planzone }) => planzone.uuid === uuid);

      return res ? res.reportTemplates : [];
    },
    isRetrieveProjectReportTemplateRequestFailure({ uuid }) {
      const res = getState().find(({ planzone }) => planzone.uuid === uuid);

      return res ? res.request.isFailure : false;
    },
    isRetrieveProjectReportTemplateRequestPending({ uuid }) {
      const res = getState().find(({ planzone }) => planzone.uuid === uuid);

      return res ? res.request.isPending : false;
    },
    isRetrieveProjectReportTemplateRequestSuccess({ uuid }) {
      const res = getState().find(({ planzone }) => planzone.uuid === uuid);

      return res ? res.request.isSuccessful : false;
    },
  };
}

export { createSelector };
